var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["sayt-trending.j2"] = require( "sayt-trending.j2" );
dependencies["sayt-popular.j2"] = require( "sayt-popular.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/enhanced-sayt.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/enhanced-sayt.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("searchUrl")) {
var t_4 = t_1.searchUrl;
} else {
cb(new Error("cannot import 'searchUrl'")); return;
}
context.setVariable("searchUrl", t_4);
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "source") == "category") {
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"sayt")),"category")),"searchSuggestions");
frame.set("searchSuggestions", t_5, true);
if(frame.topLevel) {
context.setVariable("searchSuggestions", t_5);
}
if(frame.topLevel) {
context.addExport("searchSuggestions", t_5);
}
var t_6;
t_6 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"sayt")),"category")),"showNoResultsMessage");
frame.set("showNoResultsMessage", t_6, true);
if(frame.topLevel) {
context.setVariable("showNoResultsMessage", t_6);
}
if(frame.topLevel) {
context.addExport("showNoResultsMessage", t_6);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "source") == "header") {
var t_7;
t_7 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"sayt")),"header")),"searchSuggestions");
frame.set("searchSuggestions", t_7, true);
if(frame.topLevel) {
context.setVariable("searchSuggestions", t_7);
}
if(frame.topLevel) {
context.addExport("searchSuggestions", t_7);
}
var t_8;
t_8 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"sayt")),"header")),"showNoResultsMessage");
frame.set("showNoResultsMessage", t_8, true);
if(frame.topLevel) {
context.setVariable("showNoResultsMessage", t_8);
}
if(frame.topLevel) {
context.addExport("showNoResultsMessage", t_8);
}
;
}
;
}
var t_9;
t_9 = (lineno = 11, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.sayt.header.searchTerm"]));
frame.set("searchTerm", t_9, true);
if(frame.topLevel) {
context.setVariable("searchTerm", t_9);
}
if(frame.topLevel) {
context.addExport("searchTerm", t_9);
}
output += "\n";
var t_10;
t_10 = (lineno = 12, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.enhancedSayt.display_product_results_right",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("displayProductResultsToTheRight", t_10, true);
if(frame.topLevel) {
context.setVariable("displayProductResultsToTheRight", t_10);
}
if(frame.topLevel) {
context.addExport("displayProductResultsToTheRight", t_10);
}
output += "\n";
var t_11;
t_11 = env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "popularData")) > 0;
frame.set("havePopularData", t_11, true);
if(frame.topLevel) {
context.setVariable("havePopularData", t_11);
}
if(frame.topLevel) {
context.addExport("havePopularData", t_11);
}
output += "\n";
var t_12;
t_12 = (runtime.contextOrFrameLookup(context, frame, "havePopularData") && !runtime.contextOrFrameLookup(context, frame, "displayProductResultsToTheRight")?"c-search-suggestion__sayt-trending-outer--right":"");
frame.set("trendingPositionClass", t_12, true);
if(frame.topLevel) {
context.setVariable("trendingPositionClass", t_12);
}
if(frame.topLevel) {
context.addExport("trendingPositionClass", t_12);
}
output += "\n\n\n<div class=\"c-search-suggestion js-site-search-sayt\">\n\n    <div class=\"c-search-suggestion-inner\">\n\n        ";
output += "\n        ";
output += "\n        <div class=\"c-search-suggestion__sayt-trending-outer ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "trendingPositionClass"), env.opts.autoescape);
output += "\">\n\n            <ul class=\"c-search-suggestion__ul js-site-search-sayt__ul ";
output += runtime.suppressValue((env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "searchSuggestions")) > 0?" c-search-suggestion__ul--border":""), env.opts.autoescape);
output += "\" data-qa-sayt-results>\n\n                ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "searchSuggestions")) > 0) {
output += "\n\n                    ";
frame = frame.push();
var t_15 = runtime.contextOrFrameLookup(context, frame, "searchSuggestions");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("suggestion", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\n\n                        <li class=\"c-search-suggestion__li js-site-search-sayt__li\">\n\n                            <a class=\"c-search-suggestion__a js-search-suggestion\"\n                                href=\"";
output += runtime.suppressValue((lineno = 34, colno = 48, runtime.callWrap(t_4, "searchUrl", context, ["q=" + "" + env.getFilter("replace").call(context, env.getFilter("urlencode").call(context, t_16),"%20","+")])), env.opts.autoescape);
output += "&sayt=true\"\n                                data-suggestion-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
output += "\"\n                                data-suggestion-type=\"autocomplete\"\n                                data-qa-suggestion=\"";
output += runtime.suppressValue(t_16, env.opts.autoescape);
output += "\">\n\n                                ";
output += runtime.suppressValue(t_16, env.opts.autoescape);
output += "\n\n                            </a>\n\n                            ";
output += "\n                            ";
output += "\n\n                        </li>\n\n                    ";
;
}
}
frame = frame.pop();
output += "\n\n                ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "searchTerm")) {
output += "\n                    <li class=\"c-search-suggestion__li js-site-search-sayt__li\">\n                        <a class=\"c-search-suggestion__a js-search-suggestion\"\n                            href=\"";
output += runtime.suppressValue((lineno = 53, colno = 44, runtime.callWrap(t_4, "searchUrl", context, ["q=" + "" + env.getFilter("replace").call(context, env.getFilter("urlencode").call(context, runtime.contextOrFrameLookup(context, frame, "searchTerm")),"%20","+")])), env.opts.autoescape);
output += "&sayt=true\"\n                            data-suggestion-index=\"1\"\n                            data-qa-suggestion=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "searchTerm"), env.opts.autoescape);
output += "\">\n                            ";
output += "\n                            <span class=\"c-search-suggestion__a--search-for-link\">";
output += runtime.suppressValue((lineno = 57, colno = 84, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["sayt_search_for"])), env.opts.autoescape);
output += "</span>\n                            <span class=\"c-search-suggestion__a--search-for-query\">";
output += runtime.suppressValue((lineno = 58, colno = 85, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["sayt_search_for_quotes",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "searchTerm")]})])), env.opts.autoescape);
output += "</span>\n                        </a>\n                    </li>\n                ";
;
}
;
}
output += "\n\n            </ul>\n\n            ";
if((lineno = 65, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.enhancedSayt.include_trending"])) == runtime.contextOrFrameLookup(context, frame, "True")) {
output += "\n                ";
env.getTemplate("sayt-trending.j2", false, "core/templates/enhanced-sayt.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n            ";
})});
}
output += "\n\n        </div>\n\n        ";
env.getTemplate("sayt-popular.j2", false, "core/templates/enhanced-sayt.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n        ";
output += "\n        ";
output += "\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/enhanced-sayt.j2"] , dependencies)